export class BuildingDeleteRequest {
  buildingId!: string

  constructor(buildingId: string) {
    this.buildingId = buildingId
  }
}
